const lang = {
  middleBarHead: '',
  adblock:
    'Bonjour! Ce site joue la transparence et vous donne le choix des services tiers à activer.',
  adblock_call:
    'Merci de désactiver votre adblocker pour commencer la personnalisation.',
  reload: 'Recharger la page',

  alertBigScroll: 'En continuant de défiler,',
  alertBigClick: 'En poursuivant votre navigation,',
  alertBig:
    "vous acceptez l'utilisation de services tiers pouvant installer des cookies",

  alertBigPrivacy:
    'Le Gobelet Français utilise des cookies et traceurs pour s’assurer du bon fonctionnement de ses services. Ainsi, sur la base de votre consentement des informations personnelles liées à votre navigation sur notre site sont stockées ou utilisées (telle que vos données de navigations ou l’adresse l’IP), afin de diffuser des publicités et du contenu personnalisés, mesurer la performance publicitaire et la performance du contenu, obtenir des données d’audience en lien avec cette publicité ou ce contenu et développer et améliorer les produits et services.<div id="alertBigPrivacyBottom"><b>Vous pouvez accepter et consentir</b> à l’utilisation des cookies pour l’ensemble des finalités. Vous pouvez retirer votre consentement pour l’ensemble des finalités, configurer votre consentement finalité par finalité, ou vous opposer aux traitements basés sur l’intérêt légitime en cliquant sur <b>« Personnaliser »</b>. Vous pouvez modifier votre choix à tout moment en cliquant sur <b>« Modifier mes cookies »</b> figurant en bas de chaque page.</div>',
  alertSmall: 'Gestion des services',
  acceptAll: 'Accepter et fermer',
  personalize: 'Personnaliser',
  close: 'Fermer',
  closeBanner: 'Masquer le bandeau des cookies',

  privacyUrl: 'Politique de confidentialité',

  all: 'Préférences pour tous les services',

  info: 'Protection de votre vie privée',
  disclaimer:
    "En autorisant ces services tiers, vous acceptez le dépôt et la lecture de cookies et l'utilisation de technologies de suivi nécessaires à leur bon fonctionnement.",
  allow: 'Autoriser',
  deny: 'Interdire',
  noCookie: 'Ce service ne dépose aucun cookie.',
  useCookie: 'Ce service peut déposer',
  useCookieCurrent: 'Ce service a déposé',
  useNoCookie: "Ce service n'a déposé aucun cookie.",
  more: 'En savoir plus',
  source: 'Voir le site officiel',
  credit: 'Gestion des cookies par tarteaucitron.js',
  noServices: "Ce site n'utilise aucun cookie nécessitant votre consentement.",

  toggleInfoBox:
    'Afficher/masquer les informations sur le stockage des cookies',
  title: 'Panneau de gestion des cookies',
  cookieDetail: 'Détail des cookies',
  ourSite: 'sur notre site',
  modalWindow: '(fenêtre modale)',
  newWindow: '(nouvelle fenêtre)',
  allowAll: 'Accepter et fermer',

  denyAll: 'Continuer sans accepter >',

  icon: 'Cookies',

  fallback: 'est désactivé.',
  allowed: 'autorisé',
  disallowed: 'interdit',

  ads: {
    title: 'Régies publicitaires',
    details:
      'Les régies publicitaires permettent de générer des revenus en commercialisant les espaces publicitaires du site.',
  },
  analytic: {
    title: "Mesure d'audience",
    details:
      "Les services de mesure d'audience permettent de générer des statistiques de fréquentation utiles à l'amélioration du site.",
  },
  social: {
    title: 'Réseaux sociaux',
    details:
      "Les réseaux sociaux permettent d'améliorer la convivialité du site et aident à sa promotion via les partages.",
  },
  video: {
    title: 'Vidéos',
    details:
      "Les services de partage de vidéo permettent d'enrichir le site de contenu multimédia et augmentent sa visibilité.",
  },
  comment: {
    title: 'Commentaires',
    details:
      'Les gestionnaires de commentaires facilitent le dépôt de vos commentaires et luttent contre le spam.',
  },
  support: {
    title: 'Support',
    details:
      "Les services de support vous permettent d'entrer en contact avec l'équipe du site et d'aider à son amélioration.",
  },
  api: {
    title: 'APIs',
    details:
      'Les APIs permettent de charger des scripts : géolocalisation, moteurs de recherche, traductions, ...',
  },
  google: {
    title: 'Google',
    details:
      "Les services Google permettent d'améliorer la convivialité du site et aident à sa promotion via les partages.",
  },
  other: {
    title: 'Autre',
    details: 'Services visant à afficher du contenu web.',
  },

  mandatoryTitle: 'Cookies obligatoires',
  mandatoryText:
    'Ce site utilise des cookies nécessaires à son bon fonctionnement. Ils ne peuvent pas être désactivés.',

  save: 'Enregistrer',
  ourpartners: 'Nos partenaires',
};

export default lang;
